import { Injectable, Injector } from '@angular/core';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { ReportCertificate4th } from './../model/report-certificate-4th';
import { ReportPayConstancy } from '../model/report-pay-constancy';
@Injectable()
export class ReportPayConstancyService extends BaseReportService<ReportPayConstancy> {

    public uri = '/api/reportPayConstancy/';

    constructor(injector: Injector) {
        super(injector);
        console.log('Instance ReportPayConstancyService');
    }

    buildSentence(entity?: ReportCertificate4th, event?: LazyLoadEvent): HttpParams {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-pay-constancy.service.ts